// Formats a date-only ISO string (YYYY-MM-DD) without timezone shifting.
// new Date("YYYY-MM-DD") is parsed as UTC midnight, which toLocaleDateString()
// converts to the previous day for users west of UTC. Parsing parts directly
// and using the local-timezone Date constructor avoids this.
export const formatDateOnly = (
  iso: string,
  options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    year: "numeric",
  },
): string => {
  const [year, month, day] = iso.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(undefined, options);
};

const parseYMD = (ymd: string) => {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y, m - 1, d);
};

const formatYMD = (d: Date) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const addDaysYMD = (ymd: string, n: number) => {
  const d = parseYMD(ymd);
  d.setDate(d.getDate() + n);
  return formatYMD(d);
};

export const todayYMD = () => formatYMD(new Date());

export const formatDayHeading = (ymd: string, today: string) => {
  const d = parseYMD(ymd);
  const prefix =
    ymd === today
      ? "Today"
      : d.toLocaleDateString(undefined, { weekday: "long" });
  const suffix = d.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
  });
  return `${prefix}, ${suffix}`;
};

export const formatDayName = (ymd: string) =>
  parseYMD(ymd).toLocaleDateString(undefined, { weekday: "short" });

export const formatTime = (iso: string) => {
  const d = new Date(iso);
  const hour24 = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const ampm = hour24 >= 12 ? "pm" : "am";
  const hour = hour24 % 12 || 12;
  return `${hour}:${minutes}${ampm}`;
};
